import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const LoadableBackButtonRow = lazyLoadOnRender({
  loader: () => import(/* webpackChunkName: "4-feat-applayout-backbutton" */ './BackButtonRow'),
});

export default LoadableBackButtonRow;
